import { isNil } from "lodash-es";

export enum STORAGEKEY {
   EDIT_MODE = "editMode",
   ASSORTMENT = "assortment",
   SESSION = "session",
   CAMPAIGN_SIGNUP = "campaignSignup",
   USER_NAME = "storeUsername",
   BARCODE_FOCUS_DIST = "barcodeFocusDist",
   BARCODE_DEVICE_ID = "barcodeDeviceId",
   PHONE_NUMBER = "rememberPhoneNumber",
   ORDER_TYPE = "orderType",
   DATA_VERSION = "dataVersion",
   HAS_REFRESHED = "hasRefreshed",
   LANGUAGE = "language",
   COMPANY = "company",
   LAST_COMPANY = "lastCompany",
   CART_ID = "cartId",
   VIEWED_PROMOTION_ARTICLES_KEY = "promotionArticles",
   NAVIGATION_TEST_VARIANT = "navigationtestvariant",
   LOGGING_TAGS = "loggingTags",
   CONFIG_CAT_LOG_LEVEL = "configCatLogLevel"
}

/** Generic function which returns either the item from the storage or the defaultvalue */
export const getStorage = <T>(key: STORAGEKEY, defaultValue: T, storageType?: "keepBetweenSessions" | "keepThisSession"): T => {
   if (typeof window === "undefined") return defaultValue;
   const storage = storageType === "keepBetweenSessions" ? window.localStorage : window.sessionStorage;
   const item = storage.getItem(key);
   if (isNil(item)) return defaultValue;
   try {
      return JSON.parse(item);
   } catch {
      return defaultValue;
   }
};

/** Generic function which sets the value in storage */
export const setStorage = <T>(key: STORAGEKEY, newValue: T, storageType?: "keepBetweenSessions" | "keepThisSession") => {
   const storage = storageType === "keepBetweenSessions" ? window.localStorage : window.sessionStorage;
   isNil(newValue) ? storage.removeItem(key) : storage.setItem(key, JSON.stringify(newValue));
};
